const selectors = {
  defaultRoutineInfo: (state) => state.createRoutine.defaultRoutineInfo,
  submitCreationStatus: (state) => state.createRoutine.submitCreationStatus,
};

export { selectors };
